import React from 'react';
import Section from '../components/ui/Section';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Section className="pt-32 md:pt-40">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
        <div className="prose prose-invert max-w-none space-y-6">
          <p className="text-neutral-300">Effective Date: 22/04/2025</p>
          
          <p className="text-neutral-300">
            Product Leap and ProdAI consulting ("we,") are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website Product Leap AI or interact with our services.
          </p>
          
          <p className="text-neutral-300">
            By using our website, you agree to the terms of this Privacy Policy.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">1. Who We Are</h2>
          <p className="text-neutral-300">Product Leap AI is ProdAI consulting and Product Leap.</p>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Company name: ProdAI Consulting</p>
              <p className="text-neutral-300">Business form: Eenmanszaak (sole proprietorship)</p>
              <p className="text-neutral-300">Registered with: Kamer van Koophandel (KvK), Netherlands</p>
              <p className="text-neutral-300">KvK number: 97068004</p>
              <p className="text-neutral-300">Contact: diana@prodaiconsulting.com</p>
            </div>
            <div>
              <p className="font-semibold">Company name: Product Leap</p>
              <p className="text-neutral-300">Business form: Eenmanszaak (sole proprietorship)</p>
              <p className="text-neutral-300">Registered with: Kamer van Koophandel (KvK), Netherlands</p>
              <p className="text-neutral-300">KvK number: 97343137</p>
              <p className="text-neutral-300">Contact: natalie@productleap.com</p>
            </div>
          </div>

          <h2 className="text-2xl font-bold mt-8 mb-4">2. What Information We Collect</h2>
          <p className="text-neutral-300">We may collect the following types of personal data:</p>
          <ul className="list-disc pl-6 text-neutral-300">
            <li>Contact information: such as your name, email address, phone number</li>
            <li>Business information: such as company name, role/title, project inquiries</li>
            <li>Technical data: such as IP address, browser type, pages visited (via cookies or analytics tools)</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">3. How We Use Your Information</h2>
          <p className="text-neutral-300">We use your information to:</p>
          <ul className="list-disc pl-6 text-neutral-300">
            <li>Respond to your inquiries and provide consultancy services</li>
            <li>Improve our website and services</li>
            <li>Send updates or relevant communications (with your consent)</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">4. Legal Basis for Processing</h2>
          <p className="text-neutral-300">We process your data based on:</p>
          <ul className="list-disc pl-6 text-neutral-300">
            <li>Your consent</li>
            <li>The necessity to perform a contract</li>
            <li>Our legitimate interest in running and improving our business</li>
            <li>Compliance with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">5. Sharing Your Information</h2>
          <p className="text-neutral-300">
            We do not sell your data. We may share it with trusted third parties only when necessary, such as:
          </p>
          <ul className="list-disc pl-6 text-neutral-300">
            <li>Service providers (e.g., hosting, analytics)</li>
            <li>Legal or regulatory authorities, when required</li>
          </ul>
          <p className="text-neutral-300">
            All third parties are obligated to keep your data secure and confidential.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">6. Data Retention</h2>
          <p className="text-neutral-300">
            We retain personal data only as long as necessary for the purposes outlined above or as required by law.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">7. Your Rights (under the GDPR)</h2>
          <p className="text-neutral-300">You have the right to:</p>
          <ul className="list-disc pl-6 text-neutral-300">
            <li>Access, correct, or delete your personal data</li>
            <li>Withdraw consent at any time</li>
            <li>Object to or restrict certain processing</li>
            <li>File a complaint with the Dutch Data Protection Authority (Autoriteit Persoonsgegevens)</li>
          </ul>
          <p className="text-neutral-300">
            To exercise your rights, contact us at hello@productleapai.com.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">8. Cookies</h2>
          <p className="text-neutral-300">
            We may use cookies or similar technologies to improve user experience and analyze site traffic. You can control cookies through your browser settings.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">9. Third-Party Links</h2>
          <p className="text-neutral-300">
            Our website may contain links to other websites. We are not responsible for their privacy practices. Please review their policies before submitting any data.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">10. Updates to This Policy</h2>
          <p className="text-neutral-300">
            We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Contact Us</h2>
          <p className="text-neutral-300">
            If you have any questions about this Privacy Policy, please contact us at: hello@productleapai.com
          </p>
        </div>
      </div>
    </Section>
  );
};

export default PrivacyPolicyPage;